import React, {useEffect} from 'react';
import {Actions} from '../../common/actions';
import {connect} from 'react-redux';
import './styles.scss';
import AuditFloatingInventory from './audit';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';

const FloatingInventoryAudit = (props) => {
  useEffect(() => {
    props.fetchDealers('float');
  }, []);

  useEffect(() => {
    if (
      !hasAccessPermission(props.permissions, resources.FloatingInventory, scopes.See)
    ) {
      props.navigateTo(paths.AccessDenied);
    }
  }, []);

  return <AuditFloatingInventory />;
};

const {
  fetchDealers,
  fetchFloatingClientsAudit,
  fetchFloatingInventoryAudit,
  navigateTo,
} = Actions;

const mapStateToProps = (state) => {
  return {
    'isUserTde': state.session.isUserFromTDE,
    'permissions': state.session.permissions,
  };
};

export default connect(mapStateToProps, {
  fetchDealers,
  fetchFloatingClientsAudit,
  fetchFloatingInventoryAudit,
  navigateTo,
})(FloatingInventoryAudit);
